//
//
//
//
//
//

export default {
    props: {
        btnclas: {
            default: 'submit1',
            type: String
        },
        val: {
            default: "OK",
            type: String
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/glocompoen/buttons.vue